import React from 'react';
import { BoldButton } from '@bold/web-components-react';

import IPhone from 'assets/images/global/svg/ic_phone_b.inline.svg';

import maskString from 'utils/mask-string';
import COMPANY_INFO from 'constants/company-info';

const Phone = () => {
  return (
    <p className="text-body text-center text-700 phone-wrapper">
      <IPhone alt="Bold icon" />
      <strong className="show-mobile">
        Línea de atención telefónica <br />
        {maskString(COMPANY_INFO.CONTACT.PHONE, '(###) ### ####')}
      </strong>
      <strong className="show-tablet">
        Llámanos a la línea de atenció <br /> telefónica {maskString(COMPANY_INFO.CONTACT.PHONE, '(###) ### ####')}
      </strong>
      <strong className="show-desktop">
        Llámanos a la línea de atención telefónica <br /> {maskString(COMPANY_INFO.CONTACT.PHONE, '(###) ### ####')}
      </strong>
      <BoldButton
        className="item-btn"
        onclick={() => {
          window.open(`tel:${COMPANY_INFO.CONTACT.PHONE}`, '_blank', 'noopener noreferrer');
        }}
      >
        Marcar
      </BoldButton>
    </p>
  );
};

export default Phone;
